module.exports = [{
      plugin: require('/home/ky/Sites/react-monorepo/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-80728886-38"},
    },{
      plugin: require('/home/ky/Sites/react-monorepo/src/latercera-palestina/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
